// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import ChevronDown from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import ChevronsUpDown from "@store/Library/Components/Toolkit/Icons/ChevronsUpDown";
import ChevronUp from "@store/Library/Components/Toolkit/Icons/ChevronUp";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const baseCellStyles = () => css`
    height: auto;
    border: ${pxToRem(2)} solid ${getColor("common.background") /* Store Custom Code */};
    text-align: left;
    line-height: ${x => x.theme.design.typography.lineHeight.small};
`;

const dataTable: Styleguide["dataTable"] = {
    defaultProps: {
        /* Store Custom Code - Start */
        css: css`
            border-collapse: separate;
            border-spacing: ${pxToRem(0, 2)};
        `,
        headerTypographyProps: {
            weight: 600,
            css: css`
                font-size: ${x => x.theme.design.typography.size.smaller};
            `,
        },
        cellTypographyProps: {
            css: css`
                font-size: ${x => x.theme.design.typography.size.smaller};
            `,
        },
        /* Store Custom Code - End */
        sortClickableProps: {
            css: css`
                ${focusStyles()}
                width: 100%;
                height: 100%;
                justify-content: space-between;
                color: inherit;

                &:hover {
                    text-decoration: underline;
                }
            `,
        },
        sortIconProps: {
            size: 10, // Store Custom Code
            css: css`
                color: inherit;
                margin-left: 0.5em;
            `,
        },
        sortIconSources: {
            sortable: ChevronsUpDown,
            ascending: ChevronUp,
            descending: ChevronDown,
        },
        /* Store Removed Code - border */
        cssOverrides: {
            header: css`
                ${baseCellStyles()}
                /* Store Custom Code - Start */
                padding: ${pxToRem(0, 16, 8, 4)};
                border: 0;
                border-bottom: ${pxToRem(1)} solid ${getColor("common.borderDark")};
                background-color: ${getColor("primary.contrast")};
                text-transform: uppercase;

                > button {
                    text-transform: uppercase;
                }
                /* Store Custom Code - End */
            `,
            cell: css`
                ${baseCellStyles()}
                padding: ${pxToRem(16, 16, 16, 8) /* Store Custom Code */};
                font-size: ${x => x.theme.design.typography.size.smaller /* Store Custom Code */};
                font-weight: inherit;

                /* Store Custom Code - Start */
                &:first-of-type {
                    border-left: 0;
                }

                &:last-of-type {
                    border-right: 0;
                }
                /* Store Custom Code - End */
            `,
        },
    },
};

export default dataTable;
